var map = {
	"./10sec_backward.svg": 184,
	"./10sec_forward.svg": 185,
	"./add-image-icon.svg": 372,
	"./alert-white.svg": 186,
	"./alert.svg": 54,
	"./arrow-down-icon.svg": 72,
	"./arrow-down.svg": 84,
	"./arrow-right-icon.svg": 373,
	"./arrow.svg": 374,
	"./attention.svg": 106,
	"./attentiondark.svg": 181,
	"./avatar-profile.svg": 173,
	"./avatar.svg": 171,
	"./bg.svg": 375,
	"./block-icon.svg": 187,
	"./bronze-cup-icon.svg": 376,
	"./calendar.svg": 377,
	"./camera-icon.svg": 378,
	"./camera.svg": 188,
	"./caution.svg": 127,
	"./chat.svg": 379,
	"./checked-step.svg": 152,
	"./checked.svg": 183,
	"./close-icon.svg": 174,
	"./close.svg": 189,
	"./cloud-icon.svg": 380,
	"./colapse-icon.svg": 190,
	"./collapse.svg": 381,
	"./concurrent.svg": 191,
	"./config-icon-white.svg": 192,
	"./config-icon.svg": 125,
	"./copy.svg": 382,
	"./correct.svg": 193,
	"./correct2.svg": 128,
	"./delete-white.svg": 176,
	"./delete.svg": 383,
	"./edit.svg": 384,
	"./export-icon.svg": 385,
	"./eye-color.svg": 386,
	"./eye-hide-color.svg": 387,
	"./eye.svg": 388,
	"./face-white.svg": 177,
	"./febracis.svg": 389,
	"./file-csv.svg": 194,
	"./file-doc-2.svg": 195,
	"./file-jpg.svg": 196,
	"./file-pdf.svg": 197,
	"./file-png.svg": 198,
	"./file-ppt.svg": 199,
	"./file-xls.svg": 200,
	"./file-zip.svg": 201,
	"./game-ranking.svg": 202,
	"./golden-cup-icon.svg": 390,
	"./group-icon.svg": 391,
	"./group.svg": 392,
	"./home-icon.svg": 124,
	"./icon-download.svg": 203,
	"./information-icon.svg": 393,
	"./instagram-white.svg": 179,
	"./kopa-logo.svg": 28,
	"./lang-ico.svg": 182,
	"./loading-white.svg": 129,
	"./loading.svg": 394,
	"./logo-kopa.svg": 123,
	"./logout.svg": 395,
	"./networkFailed.svg": 204,
	"./no-content.svg": 396,
	"./no-video.svg": 70,
	"./notification-icon.svg": 397,
	"./options.svg": 398,
	"./paper-icon.svg": 399,
	"./pause_overlay.svg": 205,
	"./phone.svg": 172,
	"./photo-camera.svg": 175,
	"./pin.svg": 400,
	"./pinned.svg": 206,
	"./pitch-icon.svg": 401,
	"./play.svg": 130,
	"./play_overlay.svg": 207,
	"./plus-detail-icon.svg": 402,
	"./plus-icon.svg": 403,
	"./plus.svg": 404,
	"./podium-icon.svg": 131,
	"./producer-cam-icon.svg": 95,
	"./producer-cam-mute-icon.svg": 96,
	"./producer-down-icon.svg": 405,
	"./producer-mic-icon.svg": 97,
	"./producer-mic-mute-icon.svg": 98,
	"./producer-signal-icon.svg": 406,
	"./producer-up-icon.svg": 407,
	"./qr-code-icon.svg": 408,
	"./question-2.svg": 409,
	"./quizzes-icon.svg": 410,
	"./search-icon.svg": 411,
	"./selected.svg": 412,
	"./send.svg": 413,
	"./sign-out-icon.svg": 126,
	"./silver-cup-icon.svg": 414,
	"./speedometer.svg": 415,
	"./start-transmission-icon.svg": 132,
	"./streaming.svg": 416,
	"./survey-icon.svg": 417,
	"./twitter-white.svg": 178,
	"./upload-multiple.svg": 418,
	"./upload.svg": 419,
	"./user-icon.svg": 420,
	"./video-2-icon.svg": 421,
	"./video-icon.svg": 422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 371;